/**
 * API Configuration Composable
 * Provides utilities for making authenticated API requests
 */

export const extractApiErrorMessage = (error: unknown): string => {
  console.error(error);
  return 'Une erreur est survenue';
};

export const useApiConfig = () => {
  const runtimeConfig = useRuntimeConfig();
  const supabase = useSupabaseClient();

  const baseURL = runtimeConfig.public.BACKEND_URL as string;

  /**
   * Get authentication headers for API requests
   */
  const getAuthHeaders = async (): Promise<Record<string, string>> => {
    const { data } = await supabase.auth.getSession();
    const token = data.session?.access_token;

    if (!token) {
      return {};
    }

    return {
      Authorization: `Bearer ${token}`,
    };
  };

  /**
   * Make an authenticated API request
   */
  const fetchWithAuth = async <T>(
    endpoint: string,
    options: Parameters<typeof $fetch<T>>[1] = {},
  ) => {
    const authHeaders = await getAuthHeaders();

    return $fetch<T>(`${baseURL}${endpoint}`, {
      ...options,
      headers: {
        ...authHeaders,
        ...options.headers,
      },
    });
  };

  return {
    baseURL,
    getAuthHeaders,
    fetchWithAuth,
  };
};
